import { render, staticRenderFns } from "./warehousestock.vue?vue&type=template&id=373a0b8e&scoped=true&"
import script from "./warehousestock.vue?vue&type=script&lang=js&"
export * from "./warehousestock.vue?vue&type=script&lang=js&"
import style0 from "./warehousestock.vue?vue&type=style&index=0&id=373a0b8e&scoped=true&lang=css&"
import style1 from "./warehousestock.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373a0b8e",
  null
  
)

export default component.exports